import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { UiSnackbarIntl } from '@uipath/angular/components/ui-snackbar';
import { takeUntil } from 'rxjs/operators';
var UiSnackIntl = /** @class */ (function (_super) {
    tslib_1.__extends(UiSnackIntl, _super);
    function UiSnackIntl(_translateService) {
        var _this = _super.call(this) || this;
        _this._translateService = _translateService;
        _this._updateLabels = function (_a) {
            var snackbar_close_aria_label = _a.snackbar_close_aria_label;
            _this.closeAriaLabel = snackbar_close_aria_label;
        };
        _translateService
            .stream([
            'snackbar_close_aria_label',
        ])
            .pipe(takeUntil(_this._destroyed$))
            .subscribe(_this._updateLabels);
        return _this;
    }
    return UiSnackIntl;
}(UiSnackbarIntl));
export { UiSnackIntl };
